import React from "react";

import styled from "styled-components";
function CompanyLogos() {
  return (
    <>
      {" "}
      <section className="bg-white dark:bg-gray-900 mb-2">
  <div className="max-w-screen-xl px-4 pb-8 mx-auto text-center lg:pb-16 lg:px-6">
      <figure className="max-w-screen-md mx-auto">
          <svg className="h-12 mx-auto mb-3 text-gray-400 dark:text-gray-600" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z" fill="currentColor"/>
          </svg> 
          <blockquote>
              <p className="text-2xl font-medium text-gray-900 dark:text-white">&ldquo;Uiland is just awesome. It contains over 50,000 mobile and web app screens from real world design inspiration . Perfect choice for discovering UI patterns and flows from different apps&rdquo;</p>
          </blockquote>
          <figcaption className="flex items-center justify-center mt-6 space-x-3">
              <img className="w-6 h-6 rounded-full" src="/assets/img/tassy.jpeg" alt="profile picture"/>
              <div className="flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700">
                  <div className="pr-3 font-medium text-gray-900 dark:text-white">Atasie Esther</div>
                  <div className="pl-3 text-sm font-light text-gray-500 dark:text-gray-400">Product Designer at Aether(YC W24)</div>
              </div>
          </figcaption>
      </figure>
  </div>
</section>
      <div className="px-4 mx-auto text-center overflow-hidden  lg:px-36">
        <span className="font-semibold font-silka text-gray-400 uppercase">
      Top choice by design teams at
        </span>
        <div className="flex flex-wrap justify-center items-center mt-8 text-gray-500 sm:justify-between">
          <AnimationDiv>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-white ">
              <h2 className="text-5xl font-bold font-silka ">Ebay</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Moniepoint</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Hyundai</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Fairmoney</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">SeamlessHR</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">
                YellowCard
              </h2>
            </div>{" "}
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Testgorilla</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Klasha</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Sofaboda</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-white ">
              <h2 className="text-5xl font-bold font-silka ">Paystack</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Flutterwave</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">AfriChange</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">Fairmoney</h2>
            </div>
            <div className="mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400">
              <h2 className="text-5xl font-bold font-silka ">SeamlessHR</h2>
            </div>
          </AnimationDiv>
        </div>
      </div>
    </>
  );
}
const AnimationDiv = styled.div`
  white-space: nowrap;
  width: 100vw;
  -webkit-animation: tickerScroll 40s linear infinite normal;
  animation: tickerScroll 40s linear infinite normal;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
  opacity: 0;
  -webkit-transform: translateX(0);
  transform: translateX(0);
  transition: all linear;
  will-change: transform, opacity;
  display: flex;
  flex-direction: row;
  gap: 60px;
  @keyframes tickerScroll {
    0% {
      opacity: 1;
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      opacity: 1;
      -webkit-transform: translateX(-1937px);
      transform: translateX(-1937px);
    }
  }
`;
export default CompanyLogos;
